import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CVA} from './cva';
import {UIFormEngineComponentMetadata} from './form';


@Component({
	selector: 'ui-input-radio',
	template: `
		<div class="ui-input-presentation" *ngIf="presentationMode">
			{{metadata.options.choices[cva.value]}}
		</div>


		<ng-container *ngIf="!presentationMode">

			<div class="radio-group ui-input-radio">
				<label class="ui-input-choices-label" *ngFor="let kv of metadata.options.choices|kv">

					<input type="radio" name="{{name}}" [value]="kv.key" [(ngModel)]="cva.value"
						   (ngModelChange)="set(kv.key)"/>
					{{kv.value}}
				</label>
			</div>
		</ng-container>
	`,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => UIInputRadioComponent),
			multi: true
		}
	]
})
export class UIInputRadioComponent extends CVA {
	@Input() metadata: UIFormEngineComponentMetadata;
	@Input() name;
	@Input() presentationMode = false;

	public set(val) {
		console.log('click', val);
		this.writeValueFromInput(val);
	}

}
